import React from 'react';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';
import VendorNoteForm from '../shared/form/VendorNoteForm';
import { UpdateForm, UpdateFormProps } from 'framework/form';
import useVendorNoteService from '../useVendorNoteService';

interface UpdateNoteFormProps extends Omit<UpdateFormProps, 'submitFormFunc'> {
  onCancel: () => void;
}

const UpdateVendorNoteForm = ({ onCancel, ...props }: UpdateNoteFormProps) => {
  const { getValidationSchema, update } = useVendorNoteService();

  return (
    <UpdateForm submitFormFunc={update} getValidationSchemaFunc={getValidationSchema} {...props}>
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <VendorNoteForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateVendorNoteForm;
